module.exports = __webpack_public_path__ + "img/Ryot.f5237637.png";